export const getClientApiErrorMessage = (response, formatMessage) => {
  if (!response?.errorCode) {
    return response?.message || null;
  }

  const params = response.errorParams || {};

  switch (response.errorCode) {
    case 'DUPLICATE_SIRET':
      return formatMessage({ id: 'home.client.duplicateSiret' });
    case 'DUPLICATE_COMPANY':
      return formatMessage({ id: 'home.client.duplicateCompany' });
    case 'DOMAINS_REQUIRED':
      return formatMessage({ id: 'home.client.domainsRequired' });
    case 'INVALID_DOMAIN':
      return formatMessage({ id: 'home.client.invalidDomain' }, params);
    case 'DUPLICATE_DOMAIN':
      return formatMessage({ id: 'home.client.duplicateDomain' }, params);
    case 'CONTRACT_REFERENCE_REQUIRED':
      return formatMessage({ id: 'home.client.contractReferenceRequired' });
    case 'INVALID_CONTRACT_REFERENCE':
      return formatMessage({ id: 'home.client.contractReferenceInvalid' });
    default:
      return response.message || null;
  }
};
